// Campus photo for /colleges/american-university: Public domain, by Cdover90, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHurst_Hall_American_University.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/american-university/; credited under the photo.
const photo = {
    "slug": "american-university",
    "alt": "Hurst Hall behind trees and a lawn at American University in Washington, D.C.",
    "src": "/colleges/american-university/campus-1600.webp",
    "srcSmall": "/colleges/american-university/campus-800.webp",
    "srcMid": "/colleges/american-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/american-university/og.jpg",
    "title": "Hurst Hall American University",
    "author": "Cdover90",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHurst_Hall_American_University.JPG",
    "read": "2026-10-01"
};

export default photo;
